import React, { useState, Children } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface MenuItem {
  title: string;
  url: string;
  children?: MenuItem[];
}
const menuItems: MenuItem[] = [{
  title: 'Home',
  url: '/'
}, {
  title: 'Shop All',
  url: '/shop/',
  children: [{
    title: 'Daedo PSS Systems',
    url: '/shop/daedo-pss-system/'
  }, {
    title: 'Daedo Products',
    url: '/shop/daedo-products/'
  }, {
    title: 'Wacoku Products',
    url: '/shop/wacoku-products/'
  }]
}, {
  title: 'Gen 3',
  url: '/shop/gen-3/'
}, {
  title: 'Support',
  url: 'https://www.daedosupport.com/portal/en/home',
  children: [{
    title: 'Thresholds/Hit Levels',
    url: '/thresholds'
  }, {
    title: 'Download Scoring Software',
    url: '/download'
  }, {
    title: 'Troubleshooting Video',
    url: '/daedo-truescore-troubleshooting-video'
  }, {
    title: 'E-Foot Usage Recommendations',
    url: '/E-Footgear_Usage_Recommendations'
  }]
}, {
  title: 'Financing',
  url: '/Financing.html'
}];
const isExternalUrl = (url: string) => /^https?:\/\//i.test(url);
const isHighlighted = (item: MenuItem) => item.title === 'Gen 3';
/**
 * Desktop primary navigation with hover dropdowns. Menu data is self-contained
 * in this file and is not shared with MobileMenu.
 */
export function DesktopMenu() {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  return <nav className="hidden lg:flex space-x-8" data-id="element-70">
      {menuItems.map(item => {
      const hasChildren = !!item.children?.length;
      const external = isExternalUrl(item.url);
      const highlight = isHighlighted(item);
      return <div key={item.title} className="relative" onMouseEnter={() => hasChildren && setOpenDropdown(item.title)} onMouseLeave={() => hasChildren && setOpenDropdown(null)} data-id="element-71">
            <a href={item.url || undefined} {...external ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {}} className={`text-sm font-bold uppercase tracking-wide transition-colors flex items-center gap-1 ${highlight ? 'text-red-600 hover:text-red-700' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-72">
              {item.title}
              {hasChildren && <ChevronDownIcon className="w-4 h-4" data-id="element-73" />}
            </a>

            {hasChildren && openDropdown === item.title && <div className="absolute top-full left-0 pt-2 w-64 z-50" data-id="element-74">
                <div className="bg-white border border-gray-200 rounded-lg shadow-lg py-2" data-id="element-75">
                  {item.children!.map(child => {
              const childExternal = isExternalUrl(child.url);
              return <a key={child.title} href={child.url || undefined} {...childExternal ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="block px-4 py-3 text-sm font-semibold text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors" data-id="element-76">
                        {child.title}
                      </a>;
            })}
                </div>
              </div>}
          </div>;
    })}
    </nav>;
}